import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { Store } from './redux/store/store';
import { ContextProvider } from './redux/Context';
import TagManager from 'react-gtm-module';
// import MetaPixel from './MetaPixel';
// import AdComponent from './AdComponent';
// const tagManagerArgs = {
//     gtmId: 'G-2YW9EFEKTP',
// }
// TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={Store}>
        <ContextProvider>
            {/* <MetaPixel /> */}
            {/* <AdComponent/> */}
            <App />
        </ContextProvider>
    </Provider>
);
reportWebVitals();
